import type {DiffLine} from '../../types'
import {SimpleUnifiedDiffRow} from './SimpleUnifiedDiffRow'

export function SimpleUnifiedDiffLines({diffLines, filePath}: {diffLines: DiffLine[]; filePath: string}) {
  return diffLines.map(diffLine => {
    const key = `unified-diff-row-l:${diffLine.left}-r:${diffLine.right}-b:${diffLine.blobLineNumber}`

    return <SimpleUnifiedDiffRow diffLine={diffLine} filePath={filePath} key={key} />
  })
}

try{ SimpleUnifiedDiffLines.displayName ||= 'SimpleUnifiedDiffLines' } catch {}